import { Component, OnInit } from '@angular/core';
import { SettingsService } from '@scaffold/services/settings.service';
import cloneDeep from 'lodash/cloneDeep';
import { ItemsService } from '@scaffold/services/items.service';
import { CourseService } from '../../services/course.service';
import { ScaffoldDialogRef } from '@app/framework/dialog/scaffold-dialog.service';
@Component({
    selector: 'app-item-modal',
    templateUrl: './item-modal.component.html',
    styleUrls: ['./item-modal.component.scss'],
    standalone: false
})
export class ItemModalComponent implements OnInit {
  settings;
  catagories = {};
  cats: any = [];
  accordionValue: any = [];
  cloneDeep: any = cloneDeep;
  selectedItem = null;
  list = [];
  parent;
  createdItem;
  premade = [];
  data: any = {};
  searchParam: string = '';
  constructor(
    private settingsService: SettingsService,
    public dialogRef: ScaffoldDialogRef,
    private itemsService: ItemsService,
    private courseService: CourseService
  ) {}

  closeDialog(item) {
    console.log('close');
    if (item) {
      console.log(this.createdItem, this.data.toCreate[this.createdItem]);
      if (
        this.createdItem &&
        this.data.toCreate &&
        this.data.toCreate[this.createdItem]
      ) {
        console.log('Setting used');
        this.data.toCreate[this.createdItem].used = true;
      }
      this.dialogRef.close(item);
    } else {
      this.dialogRef.close(null);
    }
  }

  changeSelection(selection) {
    if (!this.selectedItem || selection.type !== this.selectedItem.type) {
      console.log(selection);
      let select = cloneDeep(selection);
      if (this.data.toCreate) {
        let found = false;
        this.data.toCreate.forEach((i, index) => {
          if (i.type == select.type && !found && !i.used) {
            found = true;
            select = i;
            this.createdItem = index;
          }
        });
        if (!found) this.createdItem = null;
      } else {
        this.createdItem = null;
      }
      this.selectedItem = null;
      setTimeout(() => {
        this.selectedItem = select;
        console.log(this.selectedItem);
      }, 200);
    }
  }

  getCatList(cat: string): any[] {
    return this.list.filter(c => this.settings[c.type].cat === cat);
  }

  isAvailable(item) {
    var show = true;
    //console.log(item.type)
    if (this.settings[item.type].blacklist) {
      if (this.settings[item.type].blacklist.indexOf(this.parent) >= 0) {
        show = false;
      } else {
        let $this = this;
        this.settings[item.type].blacklist.forEach(function (i) {
          if (i.type && i.type == 'courses') {
            if (
              $this.courseService.data &&
              $this.courseService.data[i.key] == i.value
            ) {
              console.log($this.courseService.data[i.key], i.value);
              show = false;
            }
          }
        });
      }

      this.data.parents.forEach(v => {
        if (this.settings[item.type].blacklist.indexOf(v.type) >= 0) {
          show = false;
        }
      });
    } else if (this.settings[item.type].whitelist) {
      if (this.settings[item.type].whitelist.indexOf(this.parent) < 0) {
        show = false;
      }
    }
    return show;
  }

  ngOnInit() {
    console.log(this.data);
    this.settingsService.getSettings().subscribe(settings => {
      console.log(this.data);
      this.parent = this.data.item.type;
      this.settings = settings;
      this.data.list.forEach(item => {
        if (this.isAvailable(item)) {
          if (!this.catagories.hasOwnProperty(this.settings[item.type].cat)) {
            this.catagories[this.settings[item.type].cat] = [];
            this.cats.push(this.settings[item.type].cat);
          }
          this.catagories[this.settings[item.type].cat].push(item);
        }
      });
      this.accordionValue = this.cats.map((cat, index) => index);
      this.accordionValue.push(this.cats.length);
      this.cats.sort();
      console.log(this.catagories);
      console.log(this.courseService.data);
    });

    if (this.itemsService.viewKeys && this.itemsService.viewKeys.length > 0) {
      for (let i = 0; i < this.itemsService.viewKeys.length; i++) {
        const key = this.itemsService.viewKeys[i];

        if (key.item_desc) {
          if (key.item_desc.read) {
            this.premade.push(key.item_desc.read);
          }
          if (key.item_desc.write) {
            this.premade.push(key.item_desc.write);
          }
        }
      }
    }
    console.log(this.cats);
  }

  filter(items: any[]) {
    let filter = new RegExp(this.searchParam, 'i');
    return items.filter(i => {
      let name = this.settings[i.type].Name;
      return name.match(filter);
    });
  }
}
